import api from "./api";

export type DealItemType = "service" | "product";

export interface DealLineItem {
  id?: number;
  type: DealItemType;
  item_id: number;
  name?: string;
  quantity: number;
  unit_price: number;
  discount_amount: number;
  total_amount?: number;
}

export interface ManageDeal {
  id: number;
  title: string;
  slug?: string;
  status: "active" | "inactive" | string;
  description?: string | null;
  location_id?: number;
  location?: { id: number; name: string } | null;
  original_amount: number;
  deal_amount: number;
  formated_original_amount?: string;
  formated_deal_amount?: string;
  uses_limit?: number;
  used_time?: number;
  deal_type?: string;
  items: DealLineItem[];
  items_count?: number;
  created_at?: string;
  updated_at?: string;
}

export interface DealPayload {
  title: string;
  description?: string;
  status?: "active" | "inactive";
  location_id?: number | null;
  uses_limit?: number;
  items: Array<{
    type: DealItemType;
    id: number;
    quantity: number;
    unit_price: number;
    discount_amount?: number;
  }>;
}

export interface PaginatedDeals {
  data: ManageDeal[];
  current_page?: number;
  last_page?: number;
  total?: number;
}

const unwrap = <T>(payload: any): T => {
  if (payload?.data?.data) return payload.data.data as T;
  if (payload?.data) return payload.data as T;
  return payload as T;
};

export const getManageDeals = async (params?: {
  search?: string;
  status?: string;
  per_page?: number;
}): Promise<PaginatedDeals> => {
  const response = await api.get("/admin/deals", { params });
  const raw = unwrap<any>(response.data);
  if (Array.isArray(raw)) {
    return { data: raw };
  }
  return {
    data: Array.isArray(raw?.data) ? raw.data : [],
    current_page: raw?.current_page,
    last_page: raw?.last_page,
    total: raw?.total,
  };
};

export const getActiveDeals = async (): Promise<ManageDeal[]> => {
  const response = await api.get("/admin/deals/active");
  const raw = unwrap<any>(response.data);
  return Array.isArray(raw) ? raw : Array.isArray(raw?.data) ? raw.data : [];
};

export const getManageDeal = async (id: number | string): Promise<ManageDeal> => {
  const response = await api.get(`/admin/deals/${id}`);
  return unwrap<ManageDeal>(response.data);
};

export const createManageDeal = async (
  payload: DealPayload
): Promise<ManageDeal> => {
  const response = await api.post("/admin/deals", payload);
  return unwrap<ManageDeal>(response.data);
};

export const updateManageDeal = async (
  id: number | string,
  payload: Partial<DealPayload>
): Promise<ManageDeal> => {
  const response = await api.put(`/admin/deals/${id}`, payload);
  return unwrap<ManageDeal>(response.data);
};

export const deleteManageDeal = async (id: number | string): Promise<void> => {
  await api.delete(`/admin/deals/${id}`);
};
